import {inject} from '@angular/core';
import {ResolveFn} from '@angular/router';
import {Store} from '@ngrx/store';
import {loadProjects, retrieveProject} from './project.actions';


export const projectDetailResolver: ResolveFn<boolean> = (route, state) => {
  const store = inject(Store);
  const projectId = route.paramMap.get('projectId');
  if (!projectId) {
    return false;
  }
  store.dispatch(retrieveProject({id: +projectId}));

  return true;
};

export const projectListResolver: ResolveFn<boolean> = (route, state) => {
  const store = inject(Store);
  store.dispatch(loadProjects());
  return true;
};
